
import { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ExitIntentFormProps } from "./types";
import { SubscriptionForm } from "./SubscriptionForm";

export const MobileExitPopup = ({ 
  isVisible,
  isSliding,
  handleDismiss 
}: {
  isVisible: boolean;
  isSliding: boolean;
  handleDismiss: () => void;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div 
        className={`w-full max-w-xs bg-white rounded-lg shadow-2xl transition-all duration-300 ease-in-out transform ${
          isSliding ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
        }`}
      >
        <div className="relative p-4 bg-gradient-to-br from-blue-50/80 to-white rounded-lg">
          <Button
            variant="ghost"
            size="icon"
            className="absolute right-2 top-2 hover:bg-blue-100/50"
            onClick={handleDismiss}
          >
            <X className="h-4 w-4 text-gray-500" />
          </Button>
          
          <div className="space-y-2 mb-4">
            <h2 className="text-lg font-semibold tracking-tight text-gray-900">
              Free Home Maintenance Guide
            </h2>
            <p className="text-sm/relaxed text-gray-600">
              Stay on top of your home's upkeep — get our expert maintenance checklist!
            </p>
          </div>

          <div className="bg-white/50 backdrop-blur-sm rounded-lg p-3">
            <SubscriptionForm />
          </div>
        </div>
      </div>
    </div>
  );
};
